import React from "react";
import { useFeatureAccessibility } from "repoV2/features/CreatorDetails/modules/FeatureAccessibility/utils/useFeatureAccessibility";
import { WHITELABEL_FEATURE_KEY } from "repoV2/features/CreatorPages/constants/CreatorPages.constants";
import styles from "./DisclaimerSection.module.scss";

export const DisclaimerSection = () => {
    const isWhitelabelActive = useFeatureAccessibility({
        featureKey: WHITELABEL_FEATURE_KEY,
    });
    return (
        <section className={styles.container}>
            By providing information, you consent to sharing it with the event
            organiser and {isWhitelabelActive ? "it's platform" : "Exly"}, in
            compliance with the relevant laws.
        </section>
    );
};
